export default __webpack_public_path__ + "static/media/Emojis02.b37f804d.png";